import api from "@/services/Api";

export default {
  async getConfig() {
    try {
      const { data } = await api.get("/configurations");
      return data;
    } catch (e) {
      return false;
    }
  },

  async updatePeople({}, form) {
    try {
      const { data } = await api.post("/configurations", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },
};
